export enum MembershipType {
  Organization = 'organization',
  Retail = 'retail',
}
